<template>
  <span>{{ item.fss7Relevant ? $t("general.yes") : $t("general.no") }}</span>
</template>
<script>
export default {
  props: ["item"],
};
</script>
